import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { discordService } from '../services/discord-service';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Implicit Grant returns token in the URL fragment (hash)
    const fragment = new URLSearchParams(window.location.hash.slice(1));
    const accessToken = fragment.get('access_token');
    const errorParam = fragment.get('error');

    if (errorParam) {
      setError(`Access denied: ${fragment.get('error_description') || 'Unknown error'}`);
      return;
    }

    if (accessToken) {
      const handleLogin = async () => {
        try {
          const [userProfile, userGuilds] = await Promise.all([
            discordService.getUserProfile(accessToken),
            discordService.getUserGuilds(accessToken)
          ]);
          
          login(userProfile, userGuilds, accessToken);
          navigate('/profile');
        } catch (err: any) {
          console.error('Login failed:', err);
          setError(err.message || 'Failed to authenticate with Discord.');
        }
      };
      handleLogin();
    } else {
      // Check for code in search params in case user is redirected with code (old flow)
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('code')) {
          setError('Unexpected authorization code received. This application expects a direct access token.');
      } else {
          setError('No access token found in the redirect URL.');
      }
    }
  }, [login, navigate]);

  if (error) {
    return (
      <div className="container profile-page">
        <div className="auth-card-container">
          <div className="auth-card">
            <div className="auth-card-icon error">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <h1 className="auth-card-title">Login Failed</h1>
            <p className="auth-card-subtitle">We couldn't complete authentication with Discord.</p>
            <p className="error-message">{error}</p>
            <div className="auth-card-actions">
              <button onClick={() => navigate('/')} className="btn btn-primary">Return Home</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container profile-page">
      <div className="auth-card-container">
        <div className="auth-card">
          <div className="auth-card-icon loading">
            <svg className="spinner-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
            </svg>
          </div>
          <h1 className="auth-card-title">Authenticating...</h1>
          <p className="auth-card-subtitle">Please wait while we log you in with Discord.</p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;